import { render, staticRenderFns } from "./areaLocation.vue?vue&type=template&id=6610e8b7&scoped=true&"
import script from "./areaLocation.vue?vue&type=script&lang=js&"
export * from "./areaLocation.vue?vue&type=script&lang=js&"
import style0 from "./areaLocation.vue?vue&type=style&index=0&id=6610e8b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6610e8b7",
  null
  
)

export default component.exports